"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationActions = exports.getButtonProps = void 0;
const enums_1 = require("../enums");
const getButtonProps = (notification_user, action) => {
    var _a;
    return {
        request: {
            path: `notification_user/${notification_user.organization_id}/${notification_user.id}/action`,
            method: 'put',
            payload: { action, },
        },
        redirect: [enums_1.NotificationActionEnum.GoToConversation,].includes(action) ? `/agent/customers/${(_a = notification_user.notification) === null || _a === void 0 ? void 0 : _a.conversation_id}` : null,
    };
};
exports.getButtonProps = getButtonProps;
const getNotificationActions = (subject) => {
    const map = {
        [enums_1.NotificationSubjectEnum.NewAssignment]: [
            enums_1.NotificationActionEnum.Reject,
            enums_1.NotificationActionEnum.Accept,
        ],
        [enums_1.NotificationSubjectEnum.NewInternal]: [
            enums_1.NotificationActionEnum.Reject,
            enums_1.NotificationActionEnum.Accept,
        ],
        [enums_1.NotificationSubjectEnum.SysError]: [
            enums_1.NotificationActionEnum.OK,
        ],
        [enums_1.NotificationSubjectEnum.PasswordLifetimeExpiryClose]: [
            enums_1.NotificationActionEnum.OK,
        ],
        [enums_1.NotificationSubjectEnum.StatsAlarm]: [
            enums_1.NotificationActionEnum.OK,
        ],
    };
    return map[subject] || [
        enums_1.NotificationActionEnum.Ignore,
        enums_1.NotificationActionEnum.GoToConversation,
    ];
};
exports.getNotificationActions = getNotificationActions;
